<div class="row">
  <div class="card shadow-none rounded">
    <div class="card-body">
      <div class="col-12 col-md-12 col-xxl-12 col-xl-12">
        <div class="row">
          <div class="col-12 col-xxl-10 col-xl-10 col-md-10 col-lg-10 col-sm-10">
            <h4 class="fw-bold">Related party transactions - {{commonService.headerName}}</h4>
          </div>
          <div class="col-12 col-xxl-2 col-xl-2 col-md-2 col-lg-2 col-sm-2 text-start text-sm-end p-sm-0 pt-2">
            <button type="button" class="btn btn-outline-themecolorlight" style="padding: 7px;font-weight: 600; font-size: 14px;" tabindex="-1" (click)="TotalBack()">
              Close Accounts
            </button>
          </div>
        </div>
      </div>
      <hr />

      <div class="col-12 col-md-12 col-xxl-12 col-xl-12 col-lg-12  col-sm-12">
        <div class="row">
          <form [formGroup]="partyform">
            <div class="col-12 col-xxl-12 col-xl-12 col-md-12 col-lg-12 col-sm-12">
              <!--<h5 class="fw-bolder font-size-16">Related party transactions</h5>-->
              <div class="mb-3">
                <p class="">Please enter notes on related party transactions.</p>
                <p>If you do not have any notes to make, please return to the notes menu and de-select this section.</p>
                <!--<p>The ultimate controlling party during the period</p>-->
              </div>
              <div class="col-xl-10 col-lg-10 col-md-12 col-sm-12 col-12 mt-2">
                <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                  <label>The ultimate controlling party during the period</label>
                  <div class="mb-3">
                    <textarea class="form-control allowSpecialChars" appNumberdirective maxlength="4000" [appTooltip]="showBubbledata" rows="4" formControlName="AdditionalInformation1"></textarea>
                  </div>
                 </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-12 mt-4">
                  <label>Please enter any additional information relating to controlling party in the field below.</label>
                  <div class="mb-3">
                    <textarea class="form-control allowSpecialChars" appNumberdirective maxlength="4000" [appTooltip]="showBubbledata" rows="4" formControlName="AdditionalInformation2"></textarea>
                  </div>
                </div>

                <div class="col-lg-12 col-md-12 col-sm-12 col-12 mt-4">
                  <label>Please enter any additional information for 'Related party transactions' in the field below.</label>
                  <div class="mb-3">
                    <textarea class="form-control allowSpecialChars" appNumberdirective maxlength="4000" rows="4" [appTooltip]="showBubbledata" formControlName="AdditionalInformation3"></textarea>
                  </div>
                </div>
                </div>
            </div>
          </form>
          <div class="col-12 col-md-12 col-xxl-12 col-xl-12 col-lg-12  col-sm-12 text-end mt-4 pe-0">
            <button type="button" class="btn btn-outline-back p-1 ps-3 pe-3 me-2" (click)="back()">Back</button>
            <button type="button" class="btn themedefault p-1 ps-3 pe-3 ms-1 me-0" (click)="Insertrelatedpatrytransactions()">Next</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
